import constants from 'constants';

const {
  CPD_STATUSES
} = constants;

export const webinar = function(object) {
  let constraints = {
    webinar_type: {
      presence: true
    },
    webinar_title: {
      presence: true
    },
    expert_name: {
      presence: true
    },
    doctor_type: {
      presence: true
    },
    status: {
      presence: true
    },
    work_location: {
      presence: true
    },
    // sponsor_id: {
    //   presence: true
    // },
    cpd_points: {
      presence: true
    },
    vimeo_url: {
      format: {
        pattern: /(^\d{5,}$)|^$/,
        message: '^Vimeo uid should contain only digits with up to 9 length'
      }
    },
    counties: {
      presence: {
        message: '^Counties can\'t be blank'
      },
      length: {
        minimum: 1,
        message: '^Counties can\'t be blank'
      }
    },
    user_types: {
      presence: {
        message: '^User types can\'t be blank'
      },
      length: {
        minimum: 1,
        message: '^User types can\'t be blank'
      }
    }
  }

  if (object.cpd_status !== CPD_STATUSES.granted) {
    return constraints;
  }

  const companyNameValidation = {
    presence: {
      message: '^Company Name: can’t be blank'
    }
  };

  const cpdNumberValidation = {
    presence: {
      allowEmpty: false
    },
    numericality: true
  };

  const zoomIdValidation = {
      presence: true,
      format: {
        pattern: /^\d{5,}$/,
        message: '^Zoom uid should contain only digits with up to 9 length'
      }
  }

   switch(object.cpd_points) {
    case 'internal':
      constraints = {
        ...constraints,
        int_cpd_points: cpdNumberValidation
      }
      break;
    case 'external':
      constraints = {
        ...constraints,
        ext_cpd_points: cpdNumberValidation
      }
      break;
    case 'both':
      constraints = {
        ...constraints,
        int_cpd_points: cpdNumberValidation,
        ext_cpd_points: cpdNumberValidation
      }
      break;
   }

  switch(object.webinar_type) {
    case 'online':
      constraints = {
        ...constraints,
        zoom_uid: zoomIdValidation
      }
      break;
    case 'recorded':
      break;
  }

  switch(object.user_type) {
    case 'sponsor':
      constraints = {
        ...constraints,
        company_name: companyNameValidation
      }
      break;
    default:
      break;
  }

   return constraints;
}



/** WEBPACK FOOTER **
 ** ./src/validators/webinar.js
 **/